export enum OnboardingUserIntent {
  ActivateEInvoices = 3,
  CreateInvoices = 1,
  DiscoverAllFeatures = 4,
  TrackExpenses = 2,
}
